{
  "header": {
    "title": "Ledarinblickar",
    "description": "Utforska feedback för olika ledare",
    "exportButton": "Exportera"
  },
  "emptyState": {
    "company": {
      "title": "Inga data insamlade än",
      "description": "Din resa börjar här! När anställda börjar dela feedback under första månaden kommer du att se insikter och trender dyka upp."
    },
    "directReports": {
      "title": "Inga direktrapporter",
      "description": "Du har inga direktrapporter tilldelade dig, men du kan fortfarande delta i undersökningar och dela värdefull feedback!",
      "bottomAction": {
        "label": "Om du tror att detta är ett misstag, kontakta din chef",
        "helpText": "Hjälptext"
      }
    }
  },
  "datePicker": {
    "currentMonth": "Den här månaden",
    "lastMonth": "Förra månaden",
    "monthCount": "{{monthCount}} månader sedan"
  },
  "leaderDropdown": {
    "triggerLabel": "Ledare",
    "searchPlaceholder": "Hitta en ledare"
  },
  "columnDropdown": {
    "triggerLabel": "Kolumner",
    "options": {
      "showAll": "Visa alla kolumner",
      "hideAll": "Dölj alla kolumner"
    }
  },
  "departmentDropdown": {
    "triggerLabel": "Avdelning"
  },
  "tabs": {
    "allReports": "Alla rapporter",
    "directReports": "Direktrapporter"
  },
  "columns": {
    "leaderName": "Ledarnamn",
    "department": "Avdelning",
    "averageScore": "Genomsnittligt betyg",
    "enps": "eNPS",
    "reportCount": "Antal rapporter",
    "participationRate": "Deltagandegrad"
  },
  "loadMoreButton": "Laddar mer data",
  "labels": {
    "leader": "Ledare",
    "noResults": "Inga resultat"
  },
  "help": {
    "noResults": "Inga resultat hittades"
  },
  "detailsPage": {
    "header": {
      "name": "{{name}} team",
      "department": "{{department}} team",
      "backButton": "Tillbaka till ledarinblickar",
      "seeProfileButton": "Se profil",
      "exportButton": "Exportera"
    },
    "tabs": {
      "allReports": "Alla rapporter",
      "directReports": "Direktrapporter"
    },
    "leaderMetrics": {
      "title": "Ledarmått",
      "category": {
        "enps": {
          "name": "eNPS",
          "helpText": "Hjälptext"
        },
        "averageScore": {
          "name": "Genomsnittligt betyg",
          "helpText": "Hjälptext"
        },
        "participationRate": {
          "name": "Teamets deltagandegrad",
          "helpText": "Hjälptext"
        }
      },
      "chart": {
        "title": "Arbetstillfredsställelse poäng"
      }
    },
    "teamMetrics": {
      "title": "Genomsnittliga teammått",
      "scoreTitle": "{{name}}s team",
      "companyAverageTitle": "Företagets genomsnitt"
    },
    "keysInsights": {
      "title": "Nyckelinsikter",
      "strengths": {
        "title": "Styrkor",
        "tooltipTitle": "Hjälptext"
      },
      "growthAreas": {
        "title": "Tillväxtområden",
        "tooltipTitle": "Hjälptext"
      }
    },
    "directReport": {
      "title": "Direktrapporterande ledare",
      "empty": {
        "title": "Inga direktrapporterande ledare",
        "description": "Den här ledaren har inga underordnade ledare, eller så har uppgifter inte laddats ännu."
      }
    }
  }
}
